import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import axios from "axios";
var BASE_URL = "https://api.billiger-mietwagen.de/v1";
export var LegacyHTTPService = function LegacyHTTPService() {
    "use strict";
    _class_call_check(this, LegacyHTTPService);
    this.instance = axios.create({
        baseURL: BASE_URL,
        timeout: 8000
    });
};
